import { Outlet } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import MobileTabBar from "@/components/feature/MobileTabBar";
import LoginModal from "@/components/feature/LoginModal";
import { ToastProvider } from "@/components/feature/ToastProvider";
import { AuthProvider } from "@/components/feature/AuthProvider";

export default function Layout() {
  return (
    <ToastProvider>
      <AuthProvider>
        <div className="flex min-h-screen flex-col bg-background-50">
          <Header />
          <main className="flex-1 w-full pb-16 xl:pb-0">
            <Outlet />
          </main>
          <Footer />
          <MobileTabBar />
          <LoginModal />
        </div>
      </AuthProvider>
    </ToastProvider>
  );
}